export const GET_ALL_MARKET_GOLD_PRICE_QUERY = `
    query GetMarketGoldPriceList($input:GetMarketGoldPriceInput!,$skip:Float,$take:Float){
        getMarketGoldPriceList(where:$input,skip:$skip,take:$take){
            pageInfo {
                currentPage
                hasNextPage
                hasPreviousPage
                itemsPerPage
                totalItems
                totalPages
                }
            items{
                id
                typeGold
                salePrice
                buyPrice
                createDate
                createId
                modifyDate
                modifyId
                conditionId
                conditionType
                keyTable
                salesOrg
                channel
                district
                plant
                customer
                custgroup
                age
                mcGroup
                productId
                amountGram
                pricingUnit
                unit
                validFromDate
                validToDate
                groupPrice
                modifyId
                updateOrigin
            }
        }
    }
`;
